import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core'
import { TIPS, TipKey } from 'src/app/domain/screens'
import { ShellService } from 'src/app/services/shell.service'

/** The "?" row. 'strip' sits under the header (rt-page), 'box' inside the Schedule's dark band. One global More/Less flag. More/Less only shows when the text doesn't fit on one line. */
@Component({
  selector: 'rt-tip',
  template: `
    <div class="rt-tip rt-tip--{{ variant }}" [class.is-open]="open$ | async">
      <div class="rt-tip__row" [class.is-toggle]="overflows" (click)="onRowClick()">
        <span class="rt-tip__q" aria-hidden="true">?</span>
        <span #text class="rt-tip__text"><strong>{{ copy[0] }}</strong> {{ copy[1] }}</span>
        <button type="button" class="rt-tip__more" [style.visibility]="overflows ? 'visible' : 'hidden'" [attr.tabindex]="overflows ? 0 : -1" [attr.aria-expanded]="open$ | async">{{ (open$ | async) ? 'Less' : 'More' }}</button>
      </div>
    </div>`,
})
export class RtTipComponent implements AfterViewChecked {
  @Input() tip: TipKey = 'schedule'
  @Input() variant: 'strip' | 'box' = 'strip'
  @ViewChild('text', { static: true }) textEl!: ElementRef<HTMLElement>
  readonly open$ = this.shell.tipOpen$
  overflows = false

  constructor(readonly shell: ShellService, private cdr: ChangeDetectorRef) {}

  get copy() {
    return TIPS[this.tip]
  }

  /** Tap anywhere on the row toggles, unless the tap finished a text selection. */
  onRowClick(): void {
    if (!this.overflows) return
    if (window.getSelection()?.toString()) return
    this.shell.toggleTip()
  }

  ngAfterViewChecked(): void {
    this.measure()
  }

  @HostListener('window:resize')
  onResize(): void {
    this.measure()
  }

  /** Collapsed: clipped if scrollWidth > clientWidth. Open: wrapped if taller than one line. */
  private measure(): void {
    const el = this.textEl.nativeElement
    const open = el.closest('.rt-tip')?.classList.contains('is-open')
    const lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 20
    const next = open ? el.clientHeight > lineHeight * 1.5 : el.scrollWidth > el.clientWidth + 1
    if (next !== this.overflows) {
      this.overflows = next
      this.cdr.detectChanges()
    }
  }
}
